<template>
</template>

<script>
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems";

export default {
	name: "Home",
	created() {
		if(this.$route.fullPath === "/") {
			let redirectUrl = navMenuItems[this.$store.state.auth.role][0].url;
			this.$router.replace(redirectUrl);
		}
	}
};
</script>
